import { AxiosResponse } from 'axios';
import { ControlRequest } from '@/main/models/request/controlRequest';
import {
  ControlRegistrationDataResponse,
  ControlResponse
} from '@/main/models/response/controlResponse';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { IControlApi } from './base';

const baseRoute: string = 'Control';

export class ControlApi extends IControlApi {
  getByGroupWithPermissions(
    request: ControlRequest
  ): Promise<AxiosResponse<Result<ControlRegistrationDataResponse>>> {
    return api.get(
      `${baseRoute}/getByGroupWithPermissions?guidGroup=${request.guidUsergroup}
      &guidScreen=${request.guidScreen}&idCompanyType=${request.idCompanyType}
      &idsystemApplication=${request.idsystemApplication}`
    );
  }

  getControlsByScreenApi(
    guidScreen: string
  ): Promise<AxiosResponse<Result<ControlResponse[]>>> {
    return api.get(`${baseRoute}/allowedControls`, { params: { guidScreen } });
  }
}
